module.exports = __webpack_public_path__ + "img/characterAnime19.11ea91cc.png";